var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip.top",value:({
    content: _vm.tooltipText,
    delay: { show: 1500, hide: 0 },
    hideOnClick: true,
  }),expression:"{\n    content: tooltipText,\n    delay: { show: 1500, hide: 0 },\n    hideOnClick: true,\n  }",modifiers:{"top":true}}],staticClass:"leading-4 text-xxs text-subtle hover:text-body transition-colors",class:{ 'ml-auto': !_vm.compact }},[_c('span',[_vm._v(_vm._s(_vm.displayText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }